import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Progress, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import { Link } from "react-router-dom";
import "moment-timezone";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone, forEach } from "lodash";
import Select from "react-select";

// Import React Table HOC Fixed column
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetCivilBudgetScheduleState, getCivilBudgetSchedule as onGetCivilBudgetSchedules, addNewCivilBudgetSchedule as onAddNewCivilBudgetSchedule, updateCivilBudgetSchedule as onUpdateCivilBudgetSchedule, deleteCivilBudgetSchedule as onDeleteCivilBudgetSchedule, getCivilBudgetScheduleLoading } from "../../../store/civilBudgetSchedule/action";
import { resetCivilBudgetState, getCivilBudget as onGetCivilBudgets } from "../../../store/civilBudget/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExporMultiDoc from "../../../Components/Common/ExportMultiDoc";

const CivilBudget = () => {
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();

  const { civilBudgets, loading, error, civilBudgetSchedules, civilBudgetScheduleLoading, isCivilBudgetScheduleCreated, isCivilBudgetScheduleSuccess } = useSelector((state) => ({
    civilBudgets: state.CivilBudget.civilBudgets,
    loading: state.CivilBudget.loading,
    error: state.CivilBudget.error,
    civilBudgetSchedules: state.CivilBudgetSchedule.civilBudgetSchedules,
    civilBudgetScheduleLoading: state.CivilBudgetSchedule.loading,
    isCivilBudgetScheduleCreated: state.CivilBudgetSchedule.isCivilBudgetScheduleCreated,
    isCivilBudgetScheduleSuccess: state.CivilBudgetSchedule.isCivilBudgetScheduleSuccess
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [civilBudgetSelectList, setCivilBudgetSelectList] = useState([]);
  const [civilBudget, setCivilBudget] = useState([]);
  const [componentScheduleAddedId, setComponentScheduleAddedId] = useState(0);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [civilBudgetSchedule, setCivilBudgetSchedule] = useState([]);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [budgetName, setBudgetName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [unit, setUnit] = useState(0);
  const [totalAll, setTotalAll] = useState(0);
  const [totalReal, setTotalReal] = useState(0);
  const [totalBudget, setTotalBudget] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [expense, setExpense] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [scheduleDetail, setScheduleDetail] = useState([]);
  const [dataPrintDoc, setDataPrintDoc] = useState([])

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetCivilBudgetScheduleState());
      dispatch(resetCivilBudgetState());
      dispatch(onGetCivilBudgets());

      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setUserType(obj?.data?.userType);
        if (obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method) {
          setRoles(obj?.data?.user?.user_position?.position_role.method);
        } else setRoles(null);
      }
    }

    return () => {
      dispatch(resetCivilBudgetScheduleState());
    }
  }, [dispatch, civilBudgets, isSearch]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      setIsEdit(false);
      setCivilBudget(civilBudgets);
    }
  }, [civilBudgets, componentScheduleAddedId]);

  useEffect(() => {
    let total = 0;
    for (const element of civilBudgets) {
      let unit = !isNaN(parseFloat(element.unit)) ? parseFloat(element.unit) : 0;
      for (const data of element.cvl_detail) {
        let subtotal = !isNaN(parseFloat(data.total)) ? parseFloat(data.total) : 0;
        if (element.type === "BANGUNAN") {
          total += unit * subtotal;
        }
        else if (element.type === "UPAH") {
          total += unit * subtotal;
        }
        else {
          total += subtotal;
        }
      }
    }
    setTotalAll(total);
  }, [civilBudgets]);

  useEffect(() => {
    if (isCivilBudgetScheduleCreated) {
      dispatch(resetCivilBudgetScheduleState());
      dispatch(resetCivilBudgetState());
      dispatch(onGetCivilBudgets());
    }
  }, [dispatch, isCivilBudgetScheduleCreated]);

  useEffect(() => {
    var data = [];
    var opt = [];
    civilBudgets.forEach((item, key) => {
      const name = item.cvl_branch ? item.cvl_branch.name + ' - ' + item.name : item.name;
      const id = item.id;
      var obj = { label: name, value: id, data: item };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (civilBudgets.length > 0) {
      setCivilBudgetSelectList(data);
    }
  }, [civilBudgets]);

  useEffect(() => {
    if (!isEmpty(civilBudgetSchedules)) {
      setCivilBudgetSchedule(civilBudgetSchedules);
      setTotalWeight(civilBudgetSchedules.ttlWeight);
      setTotalBudget(civilBudgetSchedules.ttlBudget);
      setSchedule(civilBudgetSchedules.schedule);
      setScheduleDetail(civilBudgetSchedules.schedule_detail.map((item) => ({ id: `${Date.now()}-${Math.floor(Math.random() * 1000)}`, isSelected: false, ...item })));
      let rtotal = 0
      for (const s of civilBudgetSchedules.schedule_detail)
        for (const sd of s.data) {
          rtotal += sd.realization.reduce((a, v) => a = a + parseFloat(v.amount), 0);
        }
      setTotalReal(rtotal);
    }
  }, [civilBudgetSchedules]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCivilBudgetSchedule(element.value));
    });
    checkall.checked = false;
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const isAllSelected = scheduleDetail.every(
    (title) =>
      title.isSelected && title.data.every((item) => item.isSelected)
  );

  const toggleSelectAll = () => {
    const allSelected = scheduleDetail.every(
      title =>
        title.isSelected &&
        title.data.every(item => item.isSelected)
    );

    const newSelected = !allSelected;

    setScheduleDetail(prev =>
      prev.map(group => ({
        ...group,
        isSelected: newSelected,
        data: group.data.map(item => ({
          ...item,
          isSelected: newSelected
        }))
      }))
    );
  };

  const toggleTitleSelectionById = (titleId) => {
    setScheduleDetail((prevData) =>
      prevData.map((title) => {
        if (title.id !== titleId) return title;

        const newSelected = !title.isSelected;

        return {
          ...title,
          isSelected: newSelected,
          data: title.data.map((item) => ({
            ...item,
            isSelected: newSelected,
          })),
        };
      })
    );
  };

  const toggleItemSelection = (titleId, itemId) => {
    setScheduleDetail(prev =>
      prev.map(title => {
        if (title.id !== titleId) return title;

        const newData = title.data.map(item => {
          if (item.civilAccountId !== itemId) return item;
          return {
            ...item,
            isSelected: !item.isSelected,
          };
        });

        const allItemsSelected = newData.every(item => item.isSelected);

        return {
          ...title,
          isSelected: allItemsSelected,
          data: newData,
        };
      })
    );
  };


  const labels = [
    { key: "name", label: "URAIAN PEKERJAAN" },
    { key: "weight", label: "BOBOT" },
    { key: "unit", label: "VOL" },
    { key: "total", label: "HARGA" },
    { key: "total_unit", label: "TOTAL" }];

  useEffect(() => {
    const updatedData = scheduleDetail
      .map(title => {
        const filteredItems = title.data.filter(item => item.isSelected);
        const newTitleSelected = filteredItems.length > 0;
        return {
          ...title,
          isSelected: newTitleSelected,
          data: filteredItems,
        };
      })
      .filter(title => title.data.length > 0);

    const dataFinalDoc = updatedData.map(section => ({
      title: section.title,
      data: section.data.map(item => {
        const transformed = {};
        labels.forEach(({ key, label }) => {

          if (key in item) {
            if (key === "amount" || key === "total" || key === "total_unit") {
              transformed[label] = currencyFormat(item[key]);
            } if (key === "unit") {
              transformed[label] = unit;
            } else {
              transformed[label] = item[key];
            }
          }
        });

        // if ("amount" in item) {
        //   transformed["TOTAL"] = currencyFormat(parseFloat(item.quantity) * parseFloat(item.amount));
        //   transformed["TOTAL * 386"] = currencyFormat((parseFloat(item.quantity) * parseFloat(item.amount)) * unit)
        // }

        if ("realization" in item) {

          let total_realization = item.realization.reduce((a, v) => a = a + parseFloat(v.amount), 0);
          let realization = (item.unit * item.total) - item.realization.reduce((a, v) => a = a + parseFloat(v.amount), 0);


          transformed["REALISASI"] = currencyFormat(total_realization)
          transformed["SELISIH"] = currencyFormat(realization)

        }

        if ("progress" in item) {
          transformed["TP"] = item.progress
          transformed["PROGRES BANGUNAN"] = `${parseFloat((item.progress / unit) * 100).toFixed(1)}%`
        }

        if ("schedule" in item) {
          let mProgress = 0;
          let hProgress = 0;
          for (const mp of item.schedule) {
            if (parseFloat(mp.percentage) > 0) {
              mProgress++;
            }
          }
          if (mProgress > 0) {
            mProgress = unit / mProgress;
            hProgress = mProgress / 7;
          }
          transformed["/M"] = Math.ceil(mProgress)
          transformed["/H"] = Math.ceil(hProgress)

          for (const [index, el] of item.schedule.entries()) {
            transformed[el.date] = el.percentage
            transformed[`ACTUAL_${el.date}`] = el.progress > 0 ? parseFloat((item.weight / unit) * el.progress) : ""
            transformed[`KEBUTUHAN DANA_${el.date}`] = currencyFormat(parseFloat(item.total_unit / item.percentage))
          }
        }
        return transformed;
      })
    }));

    setDataPrintDoc(dataFinalDoc)
  }, [scheduleDetail])

  document.title = "Rencana Anggaran Biaya | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Jadwal Anggaran" pageTitle="Teknik" />
        <Row>
          <Col sm={12}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <div className="mb-2 flex-grow-1">
                  <h5 className="text-uppercase">Monitoring Anggaran &nbsp; {civilBudgetScheduleLoading && (
                    <>
                      <Spinner color="primary" type="grow" size={"sm"}>
                        Loading...
                      </Spinner>
                      &nbsp;
                      <Spinner color="success" type="grow" size={"sm"}>
                        Loading...
                      </Spinner>
                      &nbsp;
                    </>
                  )}</h5>
                  <h4 className="mb-1 text-uppercase text-success">{budgetName}</h4>
                  <p className="mb-1 fs-13 fw-semibold text-uppercase">{branchName}</p>
                  <p className="fs-13">{startAt !== "" && "Tanggal : " + handleValidDate(startAt) + " - " + handleValidDate(endAt)}</p>
                </div>
                <div className="flex-shrink-0">
                  <div className="mb-3" style={{ position: "relative", width: "520px", zIndex: 1000 }}>
                    <Select
                      name="branch"
                      className="text-uppercase w-100"
                      placeholder=" Pilih Aggaran Proyek"
                      style={{ position: "absolute" }}
                      onChange={(e) => {
                        //handleCivilBudgetClick(e.data);
                        setCivilBudget(e.data);
                        setBranchName(e.data.cvl_branch.name)
                        setUnit(parseInt(e.data.unit));
                        setBudgetName(e.data.name);
                        setStartAt(e.data.startat);
                        setEndAt(e.data.endat);
                        dispatch(resetCivilBudgetScheduleState());
                        dispatch(onGetCivilBudgetSchedules({ civilBudgetId: e.data.id }));
                      }}
                      options={civilBudgetSelectList}></Select>
                  </div>
                </div>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive mb-3">
                  <Table className="table-strip text-center table-nowrap align-middle mb-0">
                    <thead>
                      <tr className="table-active">
                        <th className="text-start overflow-hidden fs-14" style={{ verticalAlign: "middle" }}>REKAP ANGGARAN</th>
                        <th className="text-end overflow-hidden fs-13" style={{ width: "180px" }}>VOLUME {unit}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(civilBudgets || []).map((element, index) => {
                        let total = 0;
                        let unitBudget = !isNaN(parseFloat(element.unit)) ? parseFloat(element.unit) : 0;
                        let label = element.type === "BANGUNAN" || element.type === "UPAH" ? "(" + unit + " Unit)" : "";
                        for (const data of element.cvl_detail) {
                          let subtotal = !isNaN(parseFloat(data.total)) ? parseFloat(data.total) : 0;
                          if (element.type === "BANGUNAN" || element.type === "UPAH") {
                            total += unitBudget * subtotal;
                          }
                          else {
                            total += subtotal;
                          }
                        }
                        return (<tr key={index} className="product">
                          <td className="text-start overflow-hidden fs-13"><span className="fw-semibold text-uppercase">{element.name}</span> {label}</td>
                          <td className="text-end overflow-hidden fs-13 fw-semibold" style={{ width: "180px" }}>{currencyFormat(total)}</td>
                        </tr>);
                      })}
                    </tbody>
                    <tbody>
                      <tr className="product">
                        <td className="text-end overflow-hidden border-bottom-0 fs-13">TOTAL KEBUTUHAN ANGGARAN</td>
                        <td className="text-end overflow-hidden border-bottom-0 fs-18 text-success fw-semibold" style={{ width: "420px" }}>{currencyFormat(totalAll)}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                {
                  scheduleDetail.length > 0 &&
                  <div className="px-3 d-flex align-items-center justify-content-end">
                    <div className="flex-shrink-0">
                      <ExporMultiDoc data={dataPrintDoc} />
                    </div>
                  </div>
                }
                <div className="table-responsive table-card tableFixHead mb-0 mt-3">
                  {scheduleDetail.length > 0 && (
                    <Table className="table-border text-center table-nowrap align-middle mb-0">
                      <thead>
                        <tr className="table-active">
                          <th scope="col" className="text-start fs-14 sticky-col" style={{ background: "#FFFFFF", left: "0px", top: "0px", zIndex: 101 }}>
                            <div style={{ width: "300px" }}>
                              <input
                                id="checkBoxAll"
                                type="checkbox"
                                className="dataCheckbox form-check-input mx-2"
                                checked={isAllSelected}
                                onChange={() => {
                                  toggleSelectAll()
                                }}/>
                              URAIAN PEKERJAAN
                            </div></th>
                          <th scope="col" className="text-center fs-13 sticky-col" style={{ background: "#FFFFFF", left: "300px", zIndex: 101 }}><div style={{ width: "50px" }}>BOBOT</div></th>
                          <th scope="col" className="text-center fs-13 sticky-col" style={{ background: "#FFFFFF", left: "350px", zIndex: 101 }}><div style={{ width: "50px" }}>VOL</div></th>
                          <th scope="col" className="text-end fs-13 sticky-col" style={{ background: "#FFFFFF", left: "400px", zIndex: 101 }}><div style={{ width: "100px" }}>HARGA</div></th>
                          <th scope="col" className="text-end fs-13 sticky-col" style={{ background: "#FFFFFF", left: "515px", zIndex: 101 }}><div style={{ width: "120px" }}>TOTAL</div></th>
                          <th scope="col" className="text-end fs-13" style={{ width: "220px" }}>REALISASI</th>
                          <th scope="col" className="text-end fs-13" style={{ width: "220px" }}>SELISIH</th>
                          <th scope="col" className="text-center fs-13 sticky-col" style={{ background: "#FFFFFF", left: "650px", zIndex: 101 }}><div style={{ width: "50px" }}>TP</div></th>
                          <th scope="col" className="text-center fs-13">PROGRES BANGUNAN</th>
                          <th scope="col" className="text-center fs-13" style={{ width: "20px" }}>/M</th>
                          <th scope="col" className="text-center fs-13" style={{ width: "20px" }}>/H</th>
                          {(schedule || []).map((element, index) => {
                            return (
                              <Fragment key={index}>
                                <th scope="col" className="text-center fs-13 border-end">{element.date}</th>
                                <th scope="col" className="text-center text-muted fs-12 border-end" style={{ width: "80px" }}>ACTUAL</th>
                                <th scope="col" className="text-center text-muted fs-12 border-end" style={{ width: "120px" }}>KEBUTUHAN DANA</th>
                              </Fragment>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {(scheduleDetail || []).map((element, index) => {
                          return (
                            <Fragment key={index}>
                              <tr>
                                <td className="text-start fw-semibold fs-13 sticky-col" style={{ background: "#FFFFFF", left: "0px" }}>
                                  <div style={{ width: "300px" }}>
                                    <input
                                      id="checkBoxTitle"
                                      type="checkbox"
                                      className="dataCheckbox form-check-input mx-2"
                                      checked={element.isSelected}
                                      onChange={() => {
                                        toggleTitleSelectionById(element.id)
                                      }} />
                                    {element.title}
                                  </div></td>
                                <td colSpan={10 + (schedule.length * 3)}></td>
                              </tr>
                              {(element.data || []).map((el, idx) => {
                                let total_realization = el.realization.reduce((a, v) => a = a + parseFloat(v.amount), 0);
                                let realization = (el.unit * el.total) - el.realization.reduce((a, v) => a = a + parseFloat(v.amount), 0);

                                let mProgress = 0;
                                let hProgress = 0;
                                for (const mp of el.schedule) {
                                  if (parseFloat(mp.percentage) > 0) {
                                    mProgress++;
                                  }
                                }
                                if (mProgress > 0) {
                                  mProgress = unit / mProgress;
                                  hProgress = mProgress / 7;
                                }
                                return (
                                  <tr key={idx}>
                                    <td className="text-start fs-13 sticky-col" style={{ background: "#FFFFFF", left: "0px", zIndex: 1 }}>
                                      <div style={{ width: "300px" }}>
                                        <input
                                          id="checkBoxItem"
                                          type="checkbox"
                                          className="dataCheckbox form-check-input mx-2"
                                          checked={el.isSelected}
                                          onChange={() => {
                                            toggleItemSelection(element.id, el.civilAccountId)
                                          }}
                                        />
                                        {el.name}
                                      </div></td>
                                    <td className="text-center fw-semibold fs-13 sticky-col" style={{ background: "#FFFFFF", left: "300px", zIndex: 1 }}><div style={{ width: "50px" }}>{el.weight}</div></td>
                                    <td className="text-center fs-13 sticky-col" style={{ background: "#FFFFFF", left: "350px", zIndex: 1 }}><div style={{ width: "50px" }}>{unit}</div></td>
                                    <td className="text-end fs-13 sticky-col" style={{ background: "#FFFFFF", left: "400px", zIndex: 1 }}><div style={{ width: "100px" }}>{currencyFormat(el.total)}</div></td>
                                    <td className="text-end text-primary fw-semibold fs-13 sticky-col" style={{ background: "#FFFFFF", left: "515px", zIndex: 1 }}><div style={{ width: "120px" }}>{currencyFormat(el.total_unit)}</div></td>
                                    <td className="text-end text-info fw-semibold fs-13">
                                      <em className="fw-semibold text-info" style={{ cursor: "pointer" }} onClick={() => {
                                        setExpense(el.realization);
                                        toggle();
                                      }}>{currencyFormat(total_realization)}</em></td>
                                    <td className={realization < 1 ? "text-end text-info fw-semibold fs-13 text-danger" : "text-end text-success fw-semibold fs-13"}>{currencyFormat(realization)}</td>
                                    <td className={el.progress > 0 ? "text-center text-success fw-semibold fs-13 sticky-col" : "text-center text-warning fw-semibold fs-13 sticky-col"} style={{ background: "#FFFFFF", left: "650px", zIndex: 1 }}><div style={{ width: "50px" }}>{el.progress}</div></td>
                                    <td className="ps-4">
                                      <Progress value={((el.progress / unit) * 100)} color={((el.progress / unit) * 100) < 50 ? "danger" : ((el.progress / unit) * 100) < 80 ? "warning" : "success"} className="animated-progess custom-progress progress-label mt-3" style={{ width: "180px" }}>
                                        <div className={((el.progress / unit) * 100) < 50 ? "label text-danger bg-soft-danger fs-10" : ((el.progress / unit) * 100) < 80 ? "label text-warning bg-soft-warning fs-10" : "label text-success bg-soft-success fs-10"}>
                                          {parseFloat((el.progress / unit) * 100).toFixed(1)}%
                                        </div>
                                      </Progress>
                                    </td>
                                    <td className="text-center text-primary fw-semibold fs-13" style={{ width: "20px" }}>{Math.ceil(mProgress)}</td>
                                    <td className="text-center text-primary fw-semibold fs-13 border-end" style={{ width: "20px" }}>{Math.ceil(hProgress)}</td>
                                    {(el.schedule || []).map((ele, eleidx) => {
                                      return (
                                        <Fragment key={eleidx}>
                                          <th scope="col" className="text-center border-end"><span className={(scheduleDetail[index].data[idx].schedule[eleidx].percentage) > 0 ? "text-center p-2 w-100 bg-soft-warning" : "d-none"}>{(scheduleDetail[index].data[idx].schedule[eleidx].percentage)}</span></th>
                                          <th scope="col" className="text-center border-end"><span className={(scheduleDetail[index].data[idx].schedule[eleidx].progress) > 0 ? "text-center p-2 w-100 bg-soft-success" : "d-none"}>{scheduleDetail[index].data[idx].schedule[eleidx].progress > 0 ? parseFloat((el.weight / unit) * scheduleDetail[index].data[idx].schedule[eleidx].progress) : ""}</span></th>
                                          <th scope="col" className="text-center border-end"><span className={(scheduleDetail[index].data[idx].schedule[eleidx].percentage) > 0 ? "text-center p-2 w-100 bg-soft-info" : "d-none"}>{currencyFormat(parseFloat(el.total_unit / el.percentage))} </span></th>
                                        </Fragment>
                                      );
                                    })}
                                  </tr>
                                );
                              })}
                            </Fragment>
                          )
                        })}
                      </tbody>
                      <tfoot>
                        <tr className="table-active">
                          <th scope="col" className="text-center pt-3 pb-4 fs-13 sticky-col" style={{ background: "#FFFFFF", left: "0px", zIndex: 101 }}><div style={{ width: "300px" }}>TOTAL</div></th>
                          <th scope="col" className="text-center pt-3 pb-4 fs-14 sticky-col" style={{ background: "#FFFFFF", left: "300px", zIndex: 101 }}><div style={{ width: "50px" }}>{totalWeight}</div></th>
                          <th scope="col" className="text-center pt-3 pb-4 fs-14 sticky-col" style={{ background: "#FFFFFF", left: "350px", zIndex: 101 }}><div style={{ width: "50px" }}>{currencyFormat(unit)}</div></th>
                          <th scope="col" className="text-end pt-3 pb-4 fs-14 sticky-col" style={{ background: "#FFFFFF", left: "400px", zIndex: 101 }}><div style={{ width: "100px" }}>{currencyFormat(totalBudget)}</div></th>
                          <th scope="col" className="text-end text-primary pt-3 pb-4 fs-14 sticky-col" style={{ background: "#FFFFFF", left: "515px", zIndex: 101 }}><div style={{ width: "120px" }}>{currencyFormat(unit * totalBudget)}</div></th>
                          <th scope="col" className="text-end text-info pt-3 pb-4 fs-14">{currencyFormat(totalReal)}</th>
                          <th scope="col" className="text-end text-success pt-3 pb-4 fs-14">{currencyFormat((unit * totalBudget) - totalReal)}</th>
                          <th scope="col" className="text-center fs-13 sticky-col" style={{ background: "#FFFFFF", left: "650px", zIndex: 101 }}><div style={{ width: "50px" }}></div></th>
                          <th style={{ zIndex: 100 }}></th>
                          <th className="text-center text-primary fw-semibold fs-13" style={{ width: "20px", zIndex: 100 }}></th>
                          <th className="text-center text-primary fw-semibold fs-13" style={{ width: "20px", zIndex: 100 }}></th>
                          {(schedule || []).map((element, index) => {
                            return (
                              <Fragment key={index}>
                                <th scope="col" className="text-center pb-3 fs-14 border-bottom-0 border-end text-warning">{element.total}</th>
                                <th scope="col" className="text-center pb-3 fs-14 border-bottom-0 border-end text-success">{element.total_progress > 0 ? element.total_progress : 0}</th>
                                <th scope="col" className="text-center pb-3 fs-14 border-bottom-0 border-end text-info">{element.total_budget > 0 ? currencyFormat(parseFloat(element.total_budget)) : 0}</th>
                              </Fragment>
                            );
                          })}
                        </tr>
                      </tfoot>
                    </Table>
                  )}
                </div>
              </div>
            </Card>
          </Col>
        </Row>
        <Modal id="showModal" isOpen={modal} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggle}>DETAIL REALISASI ANGGARAN</ModalHeader>
          <ModalBody>
            <CardBody>
              <div>
                <Table className="invoice-table table-borderless table-nowrap mb-0">
                  <thead className="align-middle">
                    <tr className="table-active">
                      <td style={{ width: "20px" }}>#</td>
                      <td>Pembelian</td>
                      <td className="text-center" style={{ width: "170px" }}>No Transaksi</td>
                      <td className="text-center" style={{ width: "170px" }}>Harga Beli</td>
                      <td className="text-center" style={{ width: "170px" }}>Jumlah</td>
                      <td className="text-center" style={{ width: "150px" }}>Total</td>
                      {/* <td className="text-end" style={{ width: "35px" }}></td> */}
                    </tr>
                  </thead>
                  <tbody id="newlink">
                    {(expense || []).map((o, i) => {
                      return (
                        <tr key={i} id={i} className="product">
                          <td className="product-id">
                            {i + 1}
                          </td>
                          <td className="text-start">{o.name}</td>
                          <td className="text-center fs-13">{o.transaction_no}</td>
                          <td className="text-center fs-13">{currencyFormat(o.amount || 0)}</td>
                          <td className="text-center fs-13">{currencyFormat(o.quantity || 0)}</td>
                          <td className="text-center fs-13 fw-semibold">{currencyFormat(o.amount)}</td>
                        </tr>
                      );
                    })}
                    {expense.length === 0 && (
                      <tr>
                        <td colSpan="7" className="p-3 text-center fs-13">Belum ada realisasi</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-lg btn-light"
                onClick={() => {
                  setModal(false);
                }}>TUTUP</button>
            </div>
          </div>
        </Modal>
        
      </Container>
    </div>
  );
};
export default CivilBudget;